import { PointsState } from "src/state/tree/pointsSlice";

export const pointsSelectors = {
  getPoints: (state: PointsState) => state?.data,
  getSuspiciousPoints: (state: PointsState) => state?.data?.suspiciousPoints,
  getPointsLoading: (state: PointsState) => state?.loading,
  getPointsLoadingFailed: (state: PointsState) => !!state.error,
};
